import { useState as c, useEffect as r } from "react";
function i(e) {
  const [o, a] = c(
    () => window.matchMedia(e).matches
  );
  return r(() => {
    const t = window.matchMedia(e), n = (s) => a(s.matches);
    return t.addEventListener("change", n), a(t.matches), () => t.removeEventListener("change", n);
  }, [e]), o;
}
const d = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  useMediaQuery: i
}, Symbol.toStringTag, { value: "Module" }));
export {
  d as m,
  i as u
};
//# sourceMappingURL=useMediaQuery-B1DMwauE.mjs.map
